import { render, staticRenderFns } from "./EditMentorshipGroupJourneyAction.vue?vue&type=template&id=7cb0ecf6"
import script from "./EditMentorshipGroupJourneyAction.vue?vue&type=script&lang=js"
export * from "./EditMentorshipGroupJourneyAction.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports